import { useSelector } from 'react-redux';
import Table from '../../components/tables/Table';


const Branch = () => {
    const branches = useSelector(state => state.branches)
    const table = {
        title : 'Branches',
        tHeaders : [ 'Branch', 'Address', 'Code', 'Bank', 'State', 'Zone' ],
        tProperties : [ 'name', 'address', 'code', 'bank', 'state', 'zone' ],
    }

    return (
        <div>
            <h1>{table.title} List</h1>
            <Table table={table} data={branches} />
        </div>
    )
}

export default Branch;